import {
  applyPlanModifications,
  markExecuted,
  rejectWithRevision,
  switchToAlternative,
} from '@lotushealth/lotushealth_js_sdk/endpoints';
import type {
  ApplyPlanModificationsRequestTModificationsItem,
  ApplyPlanModificationsResultT,
  JsonValue,
  MarkExecutedResultT,
  RejectWithRevisionResultT,
  SwitchToAlternativeResultT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from './client';

export interface ProposedActionsApi {
  applyModifications(
    userId: string,
    modifications: ApplyPlanModificationsRequestTModificationsItem[]
  ): Promise<ApplyPlanModificationsResultT>;

  switchAlternative(
    userId: string,
    externalId: string,
    alternativePayloadId: string
  ): Promise<SwitchToAlternativeResultT>;

  markExecuted(
    userId: string,
    externalId: string,
    toolOutput?: Record<string, JsonValue> | null
  ): Promise<MarkExecutedResultT>;

  rejectWithRevision(
    userId: string,
    externalId: string,
    toolOutput?: Record<string, JsonValue> | null
  ): Promise<RejectWithRevisionResultT>;
}

export function createProposedActionsApi(): ProposedActionsApi {
  return {
    applyModifications: async (userId, modifications) => {
      const config = await createLotusRequestConfig();
      const response = await applyPlanModifications(userId, { modifications }, config);
      return response.data.result;
    },

    switchAlternative: async (userId, externalId, alternativePayloadId) => {
      const config = await createLotusRequestConfig();
      const response = await switchToAlternative(
        userId,
        { externalId, alternativePayloadId },
        config
      );
      return response.data.result;
    },

    markExecuted: async (userId, externalId, toolOutput) => {
      const config = await createLotusRequestConfig();
      const response = await markExecuted(userId, { externalId, toolOutput }, config);
      return response.data.result;
    },

    rejectWithRevision: async (userId, externalId, toolOutput) => {
      const config = await createLotusRequestConfig();
      const response = await rejectWithRevision(userId, { externalId, toolOutput }, config);
      return response.data.result;
    },
  };
}
